import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ib-font-italic",
  "use": "icon-ib-font-italic-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ib-font-italic\"><path d=\"M625.109333 106.666667a21.76 21.76 0 0 0-12.928 0H426.666667a21.333333 21.333333 0 1 0 0 42.666666h163.669333l-201.216 725.333334H256a21.333333 21.333333 0 0 0 0 42.666666h341.333333a21.333333 21.333333 0 1 0 0-42.666666h-163.925333l201.216-725.333334H768a21.333333 21.333333 0 0 0 0-42.666666h-142.890667z\" p-id=\"7182\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol